import {
  SHOW_MODAL,
  HIDE_MODAL,
  SET_MODAL_SIZE_SPEC,
} from '../actions/modal';

const initialState = {
  modalType: null,
  modalProps: {},
  modalSizeSpec: {
    content: {}
  }
};

export default function modal(state = initialState, action = null) {
  switch (action.type) {
    case SHOW_MODAL:
      return Object.assign({}, state, {modalType: action.modalType, modalProps: action.modalProps,});
    case HIDE_MODAL:
      return Object.assign({}, state, {modalType: null, modalProps: {}});
    case SET_MODAL_SIZE_SPEC:
      return Object.assign({}, state, {modalSizeSpec: action.modalSizeSpec});
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.js